import { Nullable } from '@starsoft/common/interfaces';

export enum GamesPreferencesActions {
  HandleChangeAmount = 'games-preferences/handle-change-amount',
  HandleChangeMultiplier = 'games-preferences/handle-change-multiplier',
  SetHalfAmount = 'games-preferences/set-half-amount',
  SetDoubleAmount = 'games-preferences/set-double-amount',
  HandleToggleAnimate = 'games-preferences/handle-toggle-animation',
  HandleDifficulty = 'games-preferences/handle-difficulty',
}

export interface GamesPreferencesStateProps {
  amount: number;
  multiplier: string;
  animate: boolean;
  difficultyId: Nullable<bigint>;
}

export interface GamesPreferencesBasePayload {
  type: string;
}

export type SetHalfAmountPayload = GamesPreferencesBasePayload;
export type SetDoubleAmountPayload = GamesPreferencesBasePayload;

export interface HandleChangeAmountPayload extends GamesPreferencesBasePayload {
  payload: {
    amount: number;
  };
}

export interface HandleChangeMultiplierPayload
  extends GamesPreferencesBasePayload {
  payload: {
    multiplier: string;
  };
}
export interface HandleAnimatePayload extends GamesPreferencesBasePayload {
  payload: {
    animate: boolean;
  };
}

export interface HandleDifficultyPayload extends GamesPreferencesBasePayload {
  payload: {
    difficultyId: bigint;
  };
}

export type GamePreferencesStatePayload =
  | GamesPreferencesStateProps
  | HandleChangeAmountPayload
  | HandleAnimatePayload
  | HandleChangeMultiplierPayload;
